import { useMutation } from "react-query";
import { updateWipMeasurements } from "components/measuring/lib/measuring-data";
import * as notify from "shared/notify";

export const useUpdateMeasurements = () => {
    return useMutation(({ measurement, sourcePage }) => updateWipMeasurements(measurement, sourcePage), {
        onError: () => notify.error("Unable to update measurement"),
    });
};
